export default class DatatableColumnsVisibilityController {
  constructor() {
    this.state = {
      isOpen: false,
    };
  }
}
